import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {findIndex} from 'lodash';

import CheckBox from '../../PageLayout/CheckBox';
import {toggleArrayValue, toggleFilterArrayValue} from "./filtersFunctions";
import {setExpandedFilters, setSelectedFilters} from "./FeaturesFiltersActions";
import PropTypes from "prop-types";
class FeaturesFiltersBodyContent extends PureComponent {

  isFilterSelected = (filter) => findIndex(this.props.selectedFilters, {filterId:filter}) !== -1;
  isFilterExpanded = (filter) => this.props.expandedFilters.includes(filter);

  handleExpandFilter = (filter) => this.props.setExpandedFilters(toggleArrayValue([...this.props.expandedFilters], filter));
  handleSelectFilter = (filterId, filterGroupId) => this.props.setSelectedFilters(
    toggleFilterArrayValue([...this.props.selectedFilters], {filterId, filterGroupId})
  );

  checkFilterGroupForAvailableFilterValues = (filterGroup) => {
    const filtersReceived = this.props.filtersReceived[this.props.activeFeaturesGroupName];
    return filterGroup && filterGroup.values.some(filterValue => {
      return filtersReceived.includes(filterValue.id);
    })
  };

  renderGenericFilters = (filterList, groupsFirst = false, groupId) => {
    // console.log('filterList', filterList);
    // const fabricatorData = this.props.fabricatorData;
    let filterOptions = filterList
      // .filter(f => !(fabricatorData && ((f.value === "Slab" && fabricatorData.isRebath)
      //   || (f.value === "DuraBath Natural Stone" && !fabricatorData.isRebath)
      // )))
      .map(f => {
        const sortedItems = (f.displayText === "Size")
          ? f.items.sort((a, b) => {
            const name1 = +a.value.split("X")[0].split("in")[0];
            const name2 = +b.value.split("X")[0].split("in")[0];
            return name1 !== name2 ? name1 < name2 ? -1 : 1 : 0
          })
          : f.items;
        let items = sortedItems.map(i => {
          return (
            <li className={"filters-body-item__expand-item"} key={i.id}>
              <CheckBox
                text={i.displayText}
                checked={this.isFilterSelected(i.id)}
                onChecked={() => this.handleSelectFilter(i.id, groupId || f.id)}/>
            </li>
          );
        });

        const expanded = this.isFilterExpanded(f.id);
        const styles = {
          height: expanded && f.items && f.items.length ? f.items.length * 40 : 0
        };

        return (
          <li className="filters-body-item" key={f.id}>
            <div className="filters-body-item__header">
              {groupsFirst ? (
                <div className="filters-body-item__header-text">{f.displayText}</div>
              ) : (
                <CheckBox
                  text={f.displayText}
                  checked={this.isFilterSelected(f.id)}
                  textOnly={groupsFirst}
                  onChecked={() => this.handleSelectFilter(f.id, groupId || f.id)}
                />
              )}
              {(f.items && f.items.length > 0)
                ? <span className={"filters-body-item__header-expand" + (expanded ? " filters-body-item__header-expand--expanded" : "")}
                        onClick={() => this.handleExpandFilter(f.id)} />
                : null}
            </div>
            <ul className={"filters-body-item__expand-items" + (expanded ? " filters-body-item__expand-items--visible" : "")}
                style={styles}>
              {items}
            </ul>
          </li>
        );
      });

    return (
      <div className="filters-body--others">
        <ul className="filters-body-items filters-body--others-container">
          {filterOptions}
        </ul>
      </div>
    );
  };

  renderBrand = (brandFilterGroup) => {
    return (
      <div className="filters-body--brand">
        <ul className="filters-body-items filters-body--brand-container">
          {this.filterByReceivedFiltersOnly(brandFilterGroup.values).map(f => (
            <li key={f.id}
                className={"filters-body-item filters-body--brand-item"
                + (this.isFilterSelected(f.id) ? " filters-body--brand-item--selected" : "")}
                style={{backgroundImage: `url(https://s3.amazonaws.com/filter-images/${f.icon})`}}
                onClick={() => this.handleSelectFilter(f.id, brandFilterGroup.id)}>
              {f.icon ? null : f.displayText}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  renderColor = (colorFilterGroup) => {
    return (
      <div className="filters-body--color">
        <ul className="filters-body-items filters-body--color-container">
          {this.filterByReceivedFiltersOnly(colorFilterGroup.values).map(f => (
            <li className="filters-body-item filters-body--color-item" key={f.id}>
              <div className={"radio"+ (this.isFilterSelected(f.id) ? " radio--selected" : "")}
                   onClick={() => this.handleSelectFilter(f.id, colorFilterGroup.id)}>{f.displayText}</div>
              {/*<CheckBox*/}
              {/*  checked={this.isFilterSelected(f.id)}*/}
              {/*  onChecked={() => this.handleSelectFilter(f.id, colorFilterGroup.id)}*/}
              {/*  text={f.displayText}/>*/}
              <span className="filters-body--color-item-preview" style={{backgroundColor: f.value}}/>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  filterByReceivedFiltersOnly = (fgValues = []) => {
    const filtersReceived = this.props.filtersReceived[this.props.activeFeaturesGroupName];
    if (!Array.isArray(filtersReceived)) {
      return []
    }
    return fgValues.filter(filterValue => filtersReceived.includes(filterValue.id))
  }

  render() {
    const filtersReceived = this.props.filtersReceived[this.props.activeFeaturesGroupName];
    switch (this.props.filterVisible) {
      case "Others": {
        const otherFilterGroups = this.props.allFilterGroups.filter(filterGroup => {
          return !["Materials", "Brand", "Color"].includes(filterGroup.name) && filterGroup.values.some(filterValue => {
            return filtersReceived && filtersReceived.includes(filterValue.id);
          })
        });
        const availableOtherFilterGroups = otherFilterGroups.map(fg => {
          return {
            id: fg.id,
            displayText: fg.name,
            items: this.filterByReceivedFiltersOnly(fg.values)
          }
        });
        return this.renderGenericFilters(availableOtherFilterGroups, true);
      }
      case "Materials": {
        const filterGroup = this.props.allFilterGroups.find(group => group.name === "Materials");
        if (this.checkFilterGroupForAvailableFilterValues(filterGroup)) {
          return this.renderGenericFilters(this.filterByReceivedFiltersOnly(filterGroup.values), false, filterGroup.id);
        }
        break;
      }
      case "Brand": {
        const filterGroup = this.props.allFilterGroups.find(group => group.name === "Brand");
        if (this.checkFilterGroupForAvailableFilterValues(filterGroup)) {
          return this.renderBrand(filterGroup);
        }
        break;
      }
      case "Color": {
        const filterGroup = this.props.allFilterGroups.find(group => group.name === "Color");
        if (this.checkFilterGroupForAvailableFilterValues(filterGroup)) {
          return this.renderColor(filterGroup);
        }
        break;
      }
    }
    return null;
  }
}

FeaturesFiltersBodyContent.propTypes = {
  featureGroupName: PropTypes.string,
}

const mapStateToProps = (store, ownProps) => {
  return {
    activeFeaturesGroupName: ownProps.featureGroupName || store.featuresCreatorNew.activeFeaturesGroupName,
    allFilterGroups: store.featuresFiltersState.allFilterGroups,
    filtersReceived: store.featuresFiltersState.filtersReceived,
    selectedFilters: store.featuresFiltersState.selectedFilters,
    expandedFilters: store.featuresFiltersState.expandedFilters,
    filterVisible: store.featuresFiltersState.filterVisible
  };
};

const mapDispatchToProps = {
  setSelectedFilters,
  setExpandedFilters
};
export default connect(mapStateToProps, mapDispatchToProps)(FeaturesFiltersBodyContent);
